/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

if (process.env.DEVTOOLS_ENABLED) {
  angular.module('bulbApp.devToolsModule', ['ui.router', 'bulbApp.authModule', 'bulbApp.configModule'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('devtools', {
          parent: 'bulbView',
          url: '^/b/devtools',
          resolve: {
            $title: ['$translate', ($translate) => $translate('sub_menu_devtools')],
          },
          views: {
            'bulbView': {
              templateUrl: 'ajs/devtools/devtools.html',
              controller: 'DevToolsController as devToolsCtrl'
            }
          }
        })
        .state('translations', {
          parent: 'bulbView',
          url: '^/b/translations',
          views: {
            'bulbView': {
              template: '<angular-translation></angular-translation>'
            }
          }
        });
    }]);
} else {
  angular.module('bulbApp.devToolsModule', []);
}
